<script setup>
defineProps({
    rows: {
        type: Number,
        default: 1
    },
    height: {
        type: String,
        default: '80px'
    }
});
</script>
<template>
    <div class="space-y-4">
        <div v-for="row in rows" :key="row" class="animate-pulse">
            <div class="bg-gray-300 rounded mb-2" :style="{ height: height, width: '100%' }"></div>
        </div>
    </div>
</template>

<style scoped>
@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}

.animate-pulse {
    animation: pulse 1.5s infinite;
}
</style>
